import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  TableContainer,
  CircularProgress,
  Alert,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  FormControlLabel,
  Checkbox,
  IconButton,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { getAccessToken } from '../../utils/auth';

function Users() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [deleteUserId, setDeleteUserId] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteError, setDeleteError] = useState('');
  const [deletingUser, setDeletingUser] = useState(false);
  const [editUser, setEditUser] = useState(null);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [editError, setEditError] = useState('');
  const [updatingUser, setUpdatingUser] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [newUser, setNewUser] = useState({
    user_id: '',
    username: '',
	name: '',
	weekHrs: '',
    mobile_number: '',
    role: 'user',
	country_code: ''
  });
  const [creatingUser, setCreatingUser] = useState(false);
  const [creationError, setCreationError] = useState('');
  const [message, setMessage] = useState('');
  const [sendSms, setSendSms] = useState(false);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    try {
      const token = await getAccessToken();
      const response = await fetch('https://app.recyconelement.dk/api/user/users.php', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token,
        },
      });

      const result = await response.json();

      if (response.ok && result.success) {
        setUsers(result.data);
      } else {
        setError(result.message || 'Fejl ved hentning af brugere');
      }
    } catch (error) {
      console.error('Fejl ved hentning af brugere:', error);
      setError('Der opstod en fejl. Prøv igen senere.');
    } finally {
      setLoading(false);
    }
  };
  
  const handleEditClick = (user) => {
    setEditUser({
      user_id: user.id,
      username: user.username,
	  name: user.name,
	  weekHrs: user.weekHrs,
      mobile_number: user.mobile_number,
      role: user.role,
      password: '',
    });
    setEditError('');
    setEditDialogOpen(true);
  };

  const handleEditChange = (field, value) => {
    setEditUser({
      ...editUser,
      [field]: value,
    });
  };

  const handleUpdateUser = async () => {
    const { user_id, username, name, weekHrs, mobile_number, role, password } = editUser;

    if (!username || !mobile_number || !role || !name) {
      setEditError('Alle felter skal udfyldes');
      return;
    }

    setUpdatingUser(true);
    setEditError('');

    try {
      const token = await getAccessToken();
      const response = await fetch('https://app.recyconelement.dk/api/user/updateUser.php', {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token,
        },
        body: JSON.stringify({ user_id, username, name, weekHrs, mobile_number, role, password }),
      });

      const result = await response.json();

      if (response.ok && result.success) {
        // Opdater brugerlisten
        fetchUsers();
        setEditDialogOpen(false);
      } else {
        setEditError(result.message || 'Fejl ved opdatering af bruger');
      }
    } catch (error) {
      console.error('Fejl ved opdatering af bruger:', error);
      setEditError('Der opstod en fejl. Prøv igen senere.');
    } finally {
      setUpdatingUser(false);
    }
  };

  const handleEditCancel = () => {
    setEditDialogOpen(false);
    setEditUser(null);
  };
  
  const handleDeleteClick = (userId) => {
    setDeleteUserId(userId);
    setDeleteError('');
    setDeleteDialogOpen(true);
  };
  
  const handleDeleteConfirm = async () => {
    setDeletingUser(true);
    setDeleteError('');

    try {
      const token = await getAccessToken();
      const response = await fetch('https://app.recyconelement.dk/api/user/deleteUser.php', {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token,
        },
        body: JSON.stringify({ user_id: deleteUserId }),
      });

      const result = await response.json();

      if (response.ok && result.success) {
        // Opdater brugerlisten
        fetchUsers();
        setDeleteDialogOpen(false);
      } else {
        setDeleteError(result.message || 'Fejl ved sletning af bruger');
      }
    } catch (error) {
      console.error('Fejl ved sletning af bruger:', error);
      setDeleteError('Der opstod en fejl. Prøv igen senere.');
    } finally {
      setDeletingUser(false);
    }
  };
  
  const handleDeleteCancel = () => {
    setDeleteDialogOpen(false);
    setDeleteUserId(null);
  };
  
  const handleOpenModal = () => {
    setNewUser({
      user_id: '',
      username: '',
	  name: '',
	  weekHrs: '',
      mobile_number: '',
      role: 'user',
	  country_code: ''
    });
    setCreationError('');
    setOpenModal(true);
  };
  
  const handleCloseModal = () => {
    setOpenModal(false);
  };const handleCreateUser = async () => {
    const { user_id, username, name, weekHrs, mobile_number, role } = newUser;

    if (!username || !mobile_number || !role || !name) {
      setCreationError('Alle felter skal udfyldes');
      return;
    }

    setCreatingUser(true);
    setCreationError('');

    try {
      const token = getAccessToken();
      const response = await fetch('https://app.recyconelement.dk/api/user/createUser.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token,
        },
        body: JSON.stringify({ user_id, username, name, weekHrs, mobile_number, role, send_sms: sendSms }),
      });

      const result = await response.json();

      if (response.ok && result.success) {
        //setGeneratedPassword(result.password);
		setMessage(result.message); // Brug beskeden fra backend
        fetchUsers(); // Opdater brugerlisten
        setOpenModal(false);
      } else {
        setCreationError(result.message || 'Fejl ved oprettelse af bruger');
      }
    } catch (error) {
      console.error('Fejl ved oprettelse af bruger:', error);
      setCreationError('Der opstod en fejl. Prøv igen senere.');
    } finally {
      setCreatingUser(false);
    }
  };

  return (
    <Container sx={{ mt: 4 }}>
      <Typography variant="h4" gutterBottom>
        Brugeroversigt
      </Typography>

      <Button variant="contained" onClick={handleOpenModal} sx={{ mb: 2 }}>
        Ny Bruger
      </Button>

      {message && (
        <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>
      )}

      {loading ? (
        <CircularProgress />
      ) : error ? (
        <Alert severity="error">{error}</Alert>
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Brugernavn</TableCell>
                <TableCell>Navn</TableCell>
                <TableCell>Timer</TableCell>
                <TableCell>Mobilnummer</TableCell>
                <TableCell>Rolle</TableCell>
                <TableCell>Oprettet</TableCell>
                <TableCell>Handlinger</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {users.map((user) => (
                <TableRow key={user.id}>
                  <TableCell>{user.id}</TableCell>
                  <TableCell>{user.username}</TableCell>
                  <TableCell>{user.name}</TableCell>
                  <TableCell>{user.weekHrs}</TableCell>
                  <TableCell>{user.mobile_number}</TableCell>
                  <TableCell>{user.role}</TableCell>
                  <TableCell>{new Date(user.created_at).toLocaleDateString()}</TableCell>
				  
				  <TableCell>
				    <IconButton aria-label="rediger" color="primary" onClick={() => handleEditClick(user)}  >
                      <EditIcon />
                    </IconButton>
                    <IconButton aria-label="slet" color="error" onClick={() => handleDeleteClick(user.id)} >
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
	  
	  {/* Sletningsbekræftelsesdialog */}
      <Dialog open={deleteDialogOpen} onClose={handleDeleteCancel}>
        <DialogTitle>Bekræft Sletning</DialogTitle>
        <DialogContent>
          {deleteError && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {deleteError}
            </Alert>
          )}
          <Typography>
            Er du sikker på, at du vil slette denne bruger? Denne handling kan ikke fortrydes.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteCancel}>Annuller</Button>
          <Button
            onClick={handleDeleteConfirm}
            variant="contained"
            color="error"
            disabled={deletingUser}
          >
            {deletingUser ? 'Sletter...' : 'Slet'}
          </Button>
        </DialogActions>
      </Dialog>
	  
	  {/* Redigeringsmodal */}
      <Dialog open={editDialogOpen} onClose={handleEditCancel}>
        <DialogTitle>Rediger Bruger</DialogTitle>
        <DialogContent>
          {editError && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {editError}
            </Alert>
          )}
          <TextField
            label="Medarbejdernummer"
            value={editUser?.user_id || ''}
            onChange={(e) => handleEditChange('user_id', e.target.value)}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Brugernavn"
            value={editUser?.username || ''}
            onChange={(e) => handleEditChange('username', e.target.value)}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Navn"
            value={editUser?.name || ''}
            onChange={(e) => handleEditChange('name', e.target.value)}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Timer (om ugen)"
            value={editUser?.weekHrs || ''}
            onChange={(e) => handleEditChange('weekHrs', e.target.value)}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Mobilnummer"
            value={editUser?.mobile_number || ''}
            onChange={(e) => handleEditChange('mobile_number', e.target.value)}
            fullWidth
            margin="normal"
          />
          <FormControl fullWidth margin="normal">
            <InputLabel id="edit-role-label">Rolle</InputLabel>
            <Select
              labelId="edit-role-label"
              value={editUser?.role || ''}
              label="Rolle"
              onChange={(e) => handleEditChange('role', e.target.value)}
            >
              <MenuItem value="user">Bruger</MenuItem>
              <MenuItem value="admin">Admin</MenuItem>
            </Select>
          </FormControl>
          <TextField
            label="Nyt Password"
            type="password"
            value={editUser?.password || ''}
            onChange={(e) => handleEditChange('password', e.target.value)}
            fullWidth
            margin="normal"
            helperText="Indtast et nyt password for at nulstille det"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEditCancel}>Annuller</Button>
          <Button
            onClick={handleUpdateUser}
            variant="contained"
            disabled={updatingUser}
          >
            {updatingUser ? 'Opdaterer...' : 'Opdater'}
          </Button>
        </DialogActions>
      </Dialog>
	  
      {/* Modal til oprettelse af ny bruger */}
      <Dialog open={openModal} onClose={handleCloseModal}>
        <DialogTitle>Opret Ny Bruger</DialogTitle>
        <DialogContent>
          {creationError && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {creationError}
            </Alert>
          )}
          <TextField
            label="Medarbejdernummer"
            value={newUser.user_id}
            onChange={(e) => setNewUser({ ...newUser, user_id: e.target.value })}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Brugernavn"
            value={newUser.username}
            onChange={(e) => setNewUser({ ...newUser, username: e.target.value })}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Navn"
            value={newUser.name}
            onChange={(e) => setNewUser({ ...newUser, name: e.target.value })}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Timer (om ugen)"
            value={newUser.weekHrs}
            onChange={(e) => setNewUser({ ...newUser, weekHrs: e.target.value })}
            fullWidth
            margin="normal"
          />
		  <TextField
              label="Mobilnummer"
			  value={newUser.mobile_number}
			  onChange={(e) => setNewUser({ ...newUser, mobile_number: e.target.value })}
              fullWidth
              margin="normal"
            />
          <FormControl fullWidth margin="normal">
            <InputLabel id="role-label">Rolle</InputLabel>
            <Select
              labelId="role-label"
              value={newUser.role}
              label="Rolle"
              onChange={(e) => setNewUser({ ...newUser, role: e.target.value })}
            >
              <MenuItem value="user">Bruger</MenuItem>
              <MenuItem value="admin">Admin</MenuItem>
            </Select>
          </FormControl>
		  <FormControlLabel
			  control={
				<Checkbox
				  checked={sendSms}
				  onChange={(e) => setSendSms(e.target.checked)}
				  color="primary"
				/>
			  }
			  label="Send SMS til bruger"
			/>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal}>Annuller</Button>
          <Button onClick={handleCreateUser} variant="contained" disabled={creatingUser}>
            {creatingUser ? 'Opretter...' : 'Opret'}
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
}

export default Users;